import React from 'react';
import PropTypes from 'prop-types';
import './CustomDashboardTooltip.scss';

const CustomDashboardTooltip = ({
  active,
  label,
  value,
  unit,
  customContent,
}) => {
  if (!active) return null;
  else if (customContent) {
    return customContent;
  }
  return (
    <div className="custom-dashboard-tooltip">
      {`${label} - ${value.toLocaleString()} ${unit}`}
    </div>
  );
};

export default CustomDashboardTooltip;
